module.exports = __webpack_public_path__ + "static/img/ent-68.68afd35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-68.jpg
// module id = fTRN
// module chunks = 51